import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../../createApiConfig'

export const lmAppsStatusApi = createApi({
  reducerPath: 'lmAppsStatusApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['AppStatus', 'AppStatusList'],
  endpoints: builder => ({
    getAppStatusList: builder.query({
      query: (params) => ({
        url: `/links/app-statuses/`,
        params,
      }),
      providesTags: ['AppStatusList']
    }),
    createAppStatus: builder.mutation({
      query: data => ({
        url: '/links/app-statuses/',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['AppStatusList']
    }),
    getAppStatusById: builder.query({
      query: id => `/links/app-statuses/${id}/`,
      providesTags: ['AppStatus']
    }),
    updateAppStatusById: builder.mutation({
      query: ({ id, data }) => ({
        url: `/links/app-statuses/${id}`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ['AppStatus']
    }),
    deleteAppStatusById: builder.mutation({
      query: id => ({
        url: `/links/app-statuses/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['AppStatusList']
    })
  })
})

export const {
  useGetAppStatusListQuery,
  useCreateAppStatusMutation,
  useGetAppStatusByIdQuery,
  useUpdateAppStatusByIdMutation,
  useDeleteAppStatusByIdMutation
} = lmAppsStatusApi
